 

export enum ProFormaModelIds {
    APARTMENT = 1,
    INDUSTRIAL = 2,
    RETAIL = 3,
    OFFICE = 4,
    DATA_CENTER = 5,
    APARTMENT_WITH_RETAIL = 6,
    STUDENT_HOUSING = 7,
    LAND_DEVELOPMENT = 8,
    RESIDENTIAL_CONDO = 9,
    HOTEL_HOSPITALITY = 10,
    SELF_STORAGE = 11
}

export enum IncomeCalculationType {
    ESTIMATE = 'estimate',
    TENANTS = 'tenants',
}

export const KEY_STATS_LABELS = {
    EXIT_VALUATION: 'Exit valuation',
    LEVERED_IRR: 'Levered IRR',
    LEVERED_EMX: 'Levered EMx',
    STAB_YIELD_ON_COST: 'Stab. yield-on-cost',
    NET_PROFIT: 'Net profit',
} as const;

export type KeyStatsLabel = typeof KEY_STATS_LABELS[keyof typeof KEY_STATS_LABELS];

export const MONTH_OPTIONS = [
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 },
];

export const ACADEMIC_YEAR_START_MONTH_OPTIONS = [
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
];

export const DEFAULT_ACADEMIC_YEAR_START_MONTH = 8; // August

